const GET_DETAIL_FABRIC_ORDER_BY_ID = 'GET_DETAIL_FABRIC_ORDER_BY_ID'
const GET_DETAIL_FABRIC_ORDER_BY_ID_SUCCESS = 'GET_DETAIL_FABRIC_ORDER_BY_ID_SUCCESS'

const PUT_FABRIC_ORDER = 'PUT_FABRIC_ORDER'
const PUT_FABRIC_ORDER_SUCCESS = 'PUT_FABRIC_ORDER_SUCCESS'

const POST_FABRIC_ORDER = 'POST_FABRIC_ORDER'
const POST_FABRIC_ORDER_SUCCESS = 'POST_FABRIC_ORDER_SUCCESS'

const GET_FABRIC_ORDER_PAGES = 'GET_FABRIC_ORDER_PAGES'
const GET_FABRIC_ORDER_PAGES_SUCCESS = 'GET_FABRIC_ORDER_PAGES_SUCCESS'

const GET_FABRIC_ORDER_LIST = 'GET_FABRIC_ORDER_LIST'
const GET_FABRIC_ORDER_LIST_SUCCESS = 'GET_FABRIC_ORDER_LIST_SUCCESS'

const GET_FABRIC_NUMBER_LIST = 'GET_FABRIC_NUMBER_LIST'
const GET_FABRIC_NUMBER_LIST_SUCCESS = 'GET_FABRIC_NUMBER_LIST_SUCCESS'

const GET_FABRIC_CUSTOMER_NAME_LIST = 'GET_FABRIC_CUSTOMER_NAME_LIST'
const GET_FABRIC_CUSTOMER_NAME_LIST_SUCCESS = 'GET_FABRIC_CUSTOMER_NAME_LIST_SUCCESS'

const GET_FABRIC_BUNCH_LIST = 'GET_FABRIC_BUNCH_LIST'
const GET_FABRIC_BUNCH_LIST_SUCCESS = 'GET_FABRIC_BUNCH_LIST_SUCCESS'

const GET_FABRIC_BRAND_LIST = 'GET_FABRIC_BRAND_LIST'
const GET_FABRIC_BRAND_LIST_SUCCESS = 'GET_FABRIC_BRAND_LIST_SUCCESS'


const FabricOrderType = {
  GET_DETAIL_FABRIC_ORDER_BY_ID,
  GET_DETAIL_FABRIC_ORDER_BY_ID_SUCCESS,

  PUT_FABRIC_ORDER,
  PUT_FABRIC_ORDER_SUCCESS,

  POST_FABRIC_ORDER,
  POST_FABRIC_ORDER_SUCCESS,

  GET_FABRIC_ORDER_PAGES,
  GET_FABRIC_ORDER_PAGES_SUCCESS,

  GET_FABRIC_ORDER_LIST,
  GET_FABRIC_ORDER_LIST_SUCCESS,

  GET_FABRIC_NUMBER_LIST,
  GET_FABRIC_NUMBER_LIST_SUCCESS,

  GET_FABRIC_CUSTOMER_NAME_LIST,
  GET_FABRIC_CUSTOMER_NAME_LIST_SUCCESS,

  GET_FABRIC_BUNCH_LIST,
  GET_FABRIC_BUNCH_LIST_SUCCESS,

  GET_FABRIC_BRAND_LIST,
  GET_FABRIC_BRAND_LIST_SUCCESS

}

export default FabricOrderType
